"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 *  Gemeinsamer Ablauf der Wand-Konfiguratoren
 *  ( confi-glasschiebewand.js , confi-keilfenster.js ,
 *    confi-festeseitenwand.js , confi-aluplankenwand.js ).
 *
 *  Aufbau wie confi-esg.js : Formular → `{wand}-infos` ( Preis ) →
 *  `{wand}-save` → `/cart/add.js` . Die Wand-Dateien liefern nur , was
 *  sich unterscheidet : Request-Body , Sichtbarkeitsregeln , Vorbelegung
 *  aus `{wand}-info/{code}` und den Wandtyp der 3D-Ansicht .
 *
 *  Eingabefelder tragen `data-field` mit dem Pfad aus dem Request
 *  ( 'width' , 'wedgeWindow.heightHigh' ) , Bereiche zum Ein- / Ausblenden
 *  `data-part` . Fachfehler des Modells stehen als
 *  `<p data-error="{errorComponent}:{errorCode}">` im Snippet.
 *
 *  Die Hilfsfunktionen ohne DOM sind in tests/confi-wall.test.js geprüft.
 */
(function (root) {
  var Debounce = 300;

  //  Zahl aus einem Eingabefeld , leer oder ungültig → null .
  //  Trenner am Anfang oder Ende zählen mit ( ',5' , '380,' beim Tippen ) .
  var number = function number(value) {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }
    if (typeof value !== 'string') {
      return null;
    }
    var text = value.trim().replace(',', '.');
    if (!/^(\d+\.?\d*|\.\d+)$/.test(text)) {
      return null;
    }
    return Number(text);
  };
  var bool = function bool(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  };

  //  Pflichtfelder ohne gültige Zahl
  var missing = function missing(values, paths) {
    return paths.filter(function (path) {
      return number(values[path]) === null;
    });
  };

  //  Fachfehler des Modells ( `error : true` mit `errorCode` ) , sonst null
  var modelError = function modelError(data) {
    if (data === null || _typeof(data) !== 'object') {
      return null;
    }
    if (data.errorCode === undefined || data.errorCode === null) {
      return null;
    }
    return {
      component: String(data.errorComponent || ''),
      code: String(data.errorCode)
    };
  };

  //  Preis , UVP und Rabatt für die Anzeige ( Menge eingerechnet )
  //  Einbauseite „vorne“ nicht anzeigen ( Glasschiebewand ohne Keilfenster ,
  //  gerade feste Wand ) : die Wand steht dann immer vorne , es gab keine Auswahl.
  //  Die Bezeichnung kommt übersetzt aus der API ( DE , NL , EN ) .
  var Position_Keys = ['Einbauseite', 'Montagezijde', 'Mounting side'];
  var withoutFrontPosition = function withoutFrontPosition(list, data) {
    return data.position === 'front' ? list.filter(function (entry) {
      return !Position_Keys.includes(entry.key);
    }) : list;
  };

  //  Pflichtfelder außerhalb von min / max der Eingabefelder → { pfad : [ min , max ] } .
  //  Das Backend erlaubt teils mehr , als verkauft wird ( Glasschiebewand
  //  50–700 cm , im Shop 200–600 cm ) .
  //  Auf min / max begrenzen und auf 'decimals' Nachkommastellen runden
  var clamp = function clamp(value, min, max) {
    var decimals = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var result = value;
    if (min !== null && result < min) result = min;
    if (max !== null && result > max) result = max;
    var factor = Math.pow(10, decimals);
    return Math.round(result * factor) / factor;
  };

  //  Mit fester Nachkommastelle und dem Dezimaltrenner der Sprache ( 380,5 / 380.5 )
  var formatDecimal = function formatDecimal(value, decimals) {
    var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    return value.toFixed(decimals).replace('.', separator);
  };

  //  Maßfelder nehmen nur Ziffern und einen Dezimaltrenner an . Punkt und
  //  Komma werden zum Trenner der Sprache , alles andere fällt weg.
  var decimalText = function decimalText(text) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
    var result = '';
    var hasSeparator = false;
    var _iterator = _createForOfIteratorHelper(String(text)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _char = _step.value;
        if (_char >= '0' && _char <= '9') {
          result += _char;
        } else if ((_char === ',' || _char === '.') && !hasSeparator) {
          result += separator;
          hasSeparator = true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  };
  var outOfRange = function outOfRange(values, paths, limits) {
    var result = {};
    var _iterator2 = _createForOfIteratorHelper(paths),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var path = _step2.value;
        var value = number(values[path]);
        var limit = limits[path];
        if (value === null || !limit) continue;
        var min = number(limit.min);
        var max = number(limit.max);
        if (min !== null && value < min || max !== null && value > max) {
          result[path] = [min, max];
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return result;
  };
  var prices = function prices(data) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var price = Number(data.price) * quantity;
    var uvp = Number(data.uvp) * quantity;
    var onSale = Number(data.uvp) > Number(data.price);
    return {
      price: price,
      uvp: uvp,
      onSale: onSale,
      savings: onSale ? uvp - price : 0,
      percent: onSale ? Math.round((uvp - price) / uvp * 100) : 0
    };
  };

  //  Positionen der Übersicht ( confi-overview , inline ) : die Wand mit ihren
  //  Angaben , je Teil der Glasschiebewand ( Keilfenster , Zugluftstopper )
  //  eine eigene Position und danach der Rabatt je Teil statt einer Summe.
  //  Preise als UVP , die Rabattzeilen ziehen ab , zusammen ergibt das 'price'.
  //  Die API liefert je Teil 'uvp' und 'discount' , die Wand ist der Rest.
  //  Die Zeilen der Teile und des Rabatts in 'properties' erkennt man an
  //  ihrer übersetzten Bezeichnung ( DE , NL , EN ) .
  var Part_Keys = {
    wedgeWindow: ['Keilfenster', 'Spieraam', 'Wedge window'],
    windSeal: ['Winddichtprofile', 'Winddichtingsprofielen', 'Wind seal profiles']
  };
  var Discount_Keys = ['Rabatt', 'Korting', 'Discount'];
  var cents = function cents(value) {
    return Math.round(value * 100) / 100;
  };
  var overviewItems = function overviewItems(list, data, texts) {
    var quantity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var amount = function amount(value) {
      return Number(value) || 0;
    };
    var properties = Array.isArray(list) ? list : [];
    var parts = Object.keys(Part_Keys).filter(function (name) {
      return data[name] !== null && _typeof(data[name]) === 'object';
    }).map(function (name) {
      return {
        label: texts.parts && texts.parts[name] || name,
        uvp: amount(data[name].uvp),
        discount: amount(data[name].discount),
        entry: properties.find(function (entry) {
          return Part_Keys[name].includes(entry.key);
        })
      };
    });
    var wall = {
      label: texts.item,
      uvp: parts.reduce(function (rest, part) {
        return rest - part.uvp;
      }, amount(data.uvp)),
      discount: parts.reduce(function (rest, part) {
        return rest - part.discount;
      }, amount(data.discount))
    };
    var shown = parts.map(function (part) {
      return part.entry;
    });
    var details = properties.filter(function (entry) {
      return !Discount_Keys.includes(entry.key) && !shown.includes(entry);
    }).map(function (entry) {
      return entry.key + ': ' + entry.value;
    });
    var items = [{
      name: wall.label,
      details: details,
      price: cents(wall.uvp * quantity),
      discount: false
    }];
    var _iterator3 = _createForOfIteratorHelper(parts),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var part = _step3.value;
        items.push({
          name: part.label,
          details: part.entry ? [String(part.entry.value)] : [],
          price: cents(part.uvp * quantity),
          discount: false
        });
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    var _iterator4 = _createForOfIteratorHelper([wall].concat(parts)),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _part = _step4.value;
        if (cents(_part.discount) > 0) {
          var name = String(texts.discount || '__PART__').replace('__PART__', _part.label);
          items.push({
            name: name,
            details: [],
            price: -cents(_part.discount * quantity),
            discount: true
          });
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return items;
  };

  //  3D-Ansicht ( Source/Viewer-3D , Builder 'wall' ) : Request-Body der Wand
  //  mit Wandtyp und gewählter Terrassen-Optik ( Holz / Alu , nur Ansicht ,
  //  geht nicht an die API ) und die Antwort von `{wand}-infos`
  var Terrace_Looks = ['wood', 'alu'];
  var viewerDetail = function viewerDetail(wallType, body, data, terrace) {
    return {
      type: 'wall',
      request: Object.assign({}, body, {
        wallType: wallType,
        terrace: Terrace_Looks.includes(terrace) ? terrace : 'wood'
      }),
      response: data
    };
  };

  ////////////////////////////////////////////////////////////////////////////

  var readField = function readField(element) {
    return element.type === 'checkbox' ? element.checked : element.value;
  };
  var writeField = function writeField(element, value) {
    if (value === undefined || value === null) {
      return;
    }
    if (element.type === 'checkbox') {
      element.checked = bool(value);
      return;
    }
    var text = String(value);
    if (element.tagName === 'SELECT') {
      if (!Array.from(element.options).some(function (option) {
        return option.value === text;
      })) {
        return;
      }
      element.value = text;
      var wrapper = element.closest('.bonsai-selector');
      if (wrapper !== null && typeof reInitBonsaiSelect === 'function') {
        reInitBonsaiSelect(wrapper);
      }
      return;
    }
    element.value = text;
  };
  var fillText = function fillText(template, value) {
    return String(template || '').replace('__VALUE__', value);
  };

  /**
   *  Startet einen Wand-Konfigurator.
   *
   *  @param definition.confi     Wert von `confi_product` ( Section-Setting )
   *  @param definition.endpoint  `{wand}` der API , z. B. 'sliding-glass-wall'
   *  @param definition.wallType  Wandtyp der 3D-Ansicht , z. B. 'slidingGlassWall'
   *  @param definition.required  ( values ) → Pfade , die eine Zahl brauchen
   *  @param definition.body      ( values ) → Request-Body ohne `country`
   *  @param definition.rules     ( values ) → { set , hidden , disabled , disabledOptions , min , max }
   *  @param definition.fromInfo  ( data ) → values aus `{wand}-info/{code}`
   *  @param definition.properties  optional , ( list , data ) → angezeigte `properties`
   *                                ( Zusammenfassung und Warenkorb )
   */
  var start = function start(definition) {
    var section = document.getElementById('ProductSection');
    if (section === null || section.getAttribute('confi') !== definition.confi) {
      return;
    }
    var confi = document.getElementById('confi');
    if (confi === null || confi.dataset.wallStarted === 'true') {
      return;
    }
    confi.dataset.wallStarted = 'true';
    var rest = {
      url: window.Steda.Routes.Root,
      api: 'api/v1/confi/'
    };
    var endpoint = function endpoint(suffix) {
      return rest.url + rest.api + definition.endpoint + suffix;
    };

    //  Buttons und Menge des Konfigurators ( confi-wall-buy.liquid ) . Zuerst im
    //  Konfigurator suchen: ein Kaufen-Block im Template bringt dieselben IDs mit.
    var inConfi = function inConfi(id) {
      return confi.querySelector('#' + id) || document.getElementById(id);
    };
    var shoppingCartBtn = inConfi('AddToCart');
    var shoppingOfferBtn = inConfi('offerRequest');
    var quantity = inConfi('Quantity');
    var errorBlock = confi.querySelector('.wall-error-message');
    var apiErrorBox = document.getElementById('confi-api-error');

    //  Übersicht ( confi-overview , inline ) : Positionen , Lieferung , Gesamt
    var overview = confi.querySelector('.confi-product-overview');
    var overviewList = overview ? overview.querySelector('.overview-list') : null;
    var overviewDelivery = overviewList ? overviewList.querySelector('li.delivery') : null;
    var confiPrice = overview ? overview.querySelector('.total-price .price') : null;
    var confiCompare = overview ? overview.querySelector('.total-price .compare-price') : null;
    var overviewTexts = {
      item: confi.dataset.textItem || '',
      discount: confi.dataset.textDiscount || '',
      parts: {
        wedgeWindow: confi.dataset.textWedgeWindow,
        windSeal: confi.dataset.textWindSeal
      }
    };

    // Preisblock der Produktseite ( snippets/product-prices.liquid ) , falls vorhanden
    var price = document.getElementById('ProductPrice');
    var comparePrice = document.getElementById('ComparePrice');
    var savingsNode = document.getElementById('SavingsPrice');
    var discountNode = document.getElementById('DiscountBadge');
    var variant_id = confi.getAttribute('variantid');
    var product_handle = confi.dataset.productHandle;
    var fields = {};
    confi.querySelectorAll('[data-field]').forEach(function (element) {
      fields[element.dataset.field] = element;
    });
    var parts = confi.querySelectorAll('[data-part]');

    //  Holz- / Alu-Optik der 3D-Ansicht : Buttons im Viewer ( Viewer-3D.liquid )
    var lookButtons = function lookButtons() {
      return document.querySelectorAll('[data-viewer-look]');
    };
    var pressedLook = document.querySelector('[data-viewer-look][aria-pressed="true"]');
    var terraceLook = pressedLook ? pressedLook.dataset.viewerLook : 'wood';
    var loadedFromCode = false;
    var lastPriceData = null;
    var sequence = 0;
    var timer = null;
    var values = function values() {
      var list = {};
      for (var path in fields) {
        list[path] = readField(fields[path]);
      }
      return list;
    };

    //  Gesperrt heißt auch : der angezeigte Preis gehört nicht zur Eingabe ( is-stale )
    //  Maßfelder ( cm ) : Textfelder mit data-decimals und min / max . Beim
    //  Tippen nur Ziffern und Komma , beim Verlassen auf min / max gesetzt und
    //  auf data-decimals Nachkommastellen gerundet ( 380,5 cm ) .
    var separator = 1.5.toLocaleString(document.documentElement.lang || undefined).charAt(1) === ',' ? ',' : '.';
    var isDecimalField = function isDecimalField(element) {
      return element.dataset.decimals !== undefined;
    };
    var limitsOf = function limitsOf(element) {
      return {
        min: number(element.getAttribute('min')),
        max: number(element.getAttribute('max')),
        decimals: parseInt(element.dataset.decimals, 10) || 0
      };
    };

    //  Unerlaubte Zeichen entfernen , Cursor bleibt hinter dem zuletzt getippten Zeichen
    var filterField = function filterField(element) {
      var _element$selectionSta;
      var text = element.value;
      var allowed = decimalText(text, separator);
      if (allowed === text) return;
      var caret = decimalText(text.slice(0, (_element$selectionSta = element.selectionStart) !== null && _element$selectionSta !== void 0 ? _element$selectionSta : text.length), separator).length;
      element.value = allowed;
      element.setSelectionRange(caret, caret);
    };
    var inRange = function inRange(element) {
      var value = number(element.value);
      var _limitsOf = limitsOf(element),
        min = _limitsOf.min,
        max = _limitsOf.max;
      return value !== null && (min === null || value >= min) && (max === null || value <= max);
    };
    var formatField = function formatField(element) {
      var value = number(element.value);
      if (value === null) return;
      var _limitsOf2 = limitsOf(element),
        min = _limitsOf2.min,
        max = _limitsOf2.max,
        decimals = _limitsOf2.decimals;
      element.value = formatDecimal(clamp(value, min, max, decimals), decimals, separator);
    };
    var lock = function lock(locked) {
      var stale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : locked;
      shoppingCartBtn.disabled = locked;
      if (shoppingOfferBtn) shoppingOfferBtn.disabled = locked;
      confi.classList.toggle('is-stale', stale);
    };
    var requestBody = function requestBody(list) {
      var body = {};
      if (typeof Shopify !== 'undefined' && Shopify.country) {
        body.country = Shopify.country;
      }
      return Object.assign(body, definition.body(list));
    };

    //  Sichtbarkeit , Sperren und Grenzen aus den Regeln der Wand
    var applyRules = function applyRules() {
      var rules = definition.rules ? definition.rules(values()) : {};
      var set = rules.set || {};
      for (var path in set) {
        if (fields[path] && readField(fields[path]) !== set[path]) {
          writeField(fields[path], set[path]);
        }
      }
      var hidden = rules.hidden || {};
      parts.forEach(function (part) {
        var name = part.dataset.part;
        part.hidden = name === 'loaded' ? !loadedFromCode : hidden[name] === true;
      });
      var disabled = rules.disabled || {};
      for (var _path in fields) {
        var off = disabled[_path] === true;
        var element = fields[_path];
        element.disabled = off;
        var wrapper = element.closest('.bonsai-selector, .bonsai-checkBox');
        if (wrapper !== null) {
          wrapper.classList.toggle('is-disabled', off);
          if (wrapper.classList.contains('bonsai-selector')) {
            if (off) wrapper.setAttribute('disabled', 'true');else wrapper.removeAttribute('disabled');
          }
        }
      }
      //  Einzelne Werte einer Auswahl sperren ( ausgegraut , nicht wählbar ) ,
      //  z. B. 8 mm Glas über 230 cm Höhe. Nur die genannten Felder.
      var disabledOptions = rules.disabledOptions || {};
      var _loop = function _loop() {
        var element = fields[_path2];
        if (!element || element.tagName !== 'SELECT') return 1; // continue
        var off = disabledOptions[_path2].map(String);
        Array.from(element.options).forEach(function (option) {
          if (off.includes(option.value)) option.setAttribute('disabled', 'true');else option.removeAttribute('disabled');
        });
        var wrapper = element.closest('.bonsai-selector');
        if (wrapper !== null && typeof reInitBonsaiSelect === 'function') {
          reInitBonsaiSelect(wrapper, true);
        }
      };
      for (var _path2 in disabledOptions) {
        if (_loop()) continue;
      }
      //  Grenzen , die von anderen Feldern abhängen ( z. B. Höhen über der
      //  Durchgangshöhe ) : gelten für die Prüfung und das Begrenzen beim Verlassen
      var min = rules.min || {};
      for (var _path3 in min) {
        if (fields[_path3]) fields[_path3].setAttribute('min', min[_path3]);
      }
      var max = rules.max || {};
      for (var _path4 in max) {
        if (fields[_path4]) fields[_path4].setAttribute('max', max[_path4]);
      }
      return values();
    };

    ////////////////////////////////////////////////////////////////////////
    //  Fehler

    var errorFields = {};
    for (var path in fields) {
      errorFields[path] = fields[path];
    }
    var hideModelErrors = function hideModelErrors() {
      if (errorBlock === null) return;
      errorBlock.querySelectorAll('p').forEach(function (p) {
        p.hidden = true;
      });
    };
    var clearErrors = function clearErrors() {
      hideModelErrors();
      ConfiErrors.hide(apiErrorBox, confi);
    };
    var showApiError = function showApiError(result) {
      hideModelErrors();
      ConfiErrors.show(result, {
        container: apiErrorBox,
        title: document.getElementById('confi-api-error-title'),
        text: document.getElementById('confi-api-error-text'),
        fields: errorFields,
        scope: confi
      });
      lock(true);
    };

    //  Maße außerhalb der Grenzen im Snippet : Meldung am Feld wie bei der
    //  Validierung des Backends , ohne Request. true , wenn etwas falsch ist.
    var checkRange = function checkRange(list) {
      var limits = {};
      for (var _path5 in fields) {
        limits[_path5] = {
          min: fields[_path5].getAttribute('min'),
          max: fields[_path5].getAttribute('max')
        };
      }
      var wrong = outOfRange(list, definition.required(list), limits);
      var paths = Object.keys(wrong);
      if (paths.length === 0) return false;
      var errors = {};
      for (var _i = 0, _paths = paths; _i < _paths.length; _i++) {
        var _path6 = _paths[_i];
        var _wrong$_path = _slicedToArray(wrong[_path6], 2),
          min = _wrong$_path[0],
          max = _wrong$_path[1];
        errors[_path6] = [String(confi.dataset.textRange || '').replace('__MIN__', String(min).replace('.', ',')).replace('__MAX__', String(max).replace('.', ','))];
      }
      // laufende Preisberechnungen verwerfen
      ++sequence;
      showApiError({
        status: 422,
        message: '',
        errors: errors
      });
      return true;
    };

    //  Fachfehler : passender Hinweis aus dem Snippet , sonst technischer Fehler
    var showModelError = function showModelError(error) {
      ConfiErrors.hide(apiErrorBox, confi);
      hideModelErrors();
      if (errorBlock !== null) {
        var hint = errorBlock.querySelector('[data-error="' + error.component + ':' + error.code + '"]') || errorBlock.querySelector('[data-error="technical"]');
        if (hint !== null) hint.hidden = false;
      }
      lock(true);
    };

    //  Abgelehnte Antwort : Fachfehler ( errorCode ) oder Validierung über ConfiErrors
    var showFailure = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
        var data, error, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return response.clone().json()["catch"](function () {
                return {};
              });
            case 1:
              data = _context.v;
              error = modelError(data);
              if (!(error !== null)) {
                _context.n = 2;
                break;
              }
              showModelError(error);
              _context.n = 4;
              break;
            case 2:
              _t = showApiError;
              _context.n = 3;
              return ConfiErrors.read(response);
            case 3:
              _t(_context.v);
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function showFailure(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    ////////////////////////////////////////////////////////////////////////
    //  Preis

    //  Properties der Antwort , die die Wand anzeigen will ( definition.properties )
    var visibleProperties = function visibleProperties(data) {
      var list = Array.isArray(data.properties) ? data.properties : [];
      return typeof definition.properties === 'function' ? definition.properties(list, data) : list;
    };
    var quantityValue = function quantityValue() {
      return Math.max(1, parseInt(quantity ? quantity.value : 1, 10) || 1);
    };

    //  Positionen vor die Lieferung , Aufbau wie addToOverview der
    //  Produkt-Konfiguratoren ( .item mit .name und .desc , .price )
    var renderOverview = function renderOverview(items) {
      if (overviewList === null) return;
      overviewList.querySelectorAll('li:not(.delivery)').forEach(function (li) {
        return li.remove();
      });
      var _iterator5 = _createForOfIteratorHelper(items),
        _step5;
      try {
        var _loop2 = function _loop2() {
          var entry = _step5.value;
          var li = document.createElement('li');
          var item = document.createElement('div');
          var name = document.createElement('div');
          var price = document.createElement('div');
          item.className = 'item';
          name.className = 'name';
          price.className = 'price';
          name.textContent = entry.name;
          item.appendChild(name);
          if (entry.details.length > 0) {
            var desc = document.createElement('div');
            desc.className = 'desc';
            entry.details.forEach(function (line, index) {
              if (index > 0) desc.appendChild(document.createElement('br'));
              desc.appendChild(document.createTextNode(line));
            });
            item.appendChild(desc);
          }
          price.textContent = entry.price < 0 ? '-' + number2money(-entry.price) : number2money(entry.price);
          if (entry.discount) li.classList.add('discount');
          li.appendChild(item);
          li.appendChild(price);
          overviewList.insertBefore(li, overviewDelivery);
        };
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      if (overviewDelivery !== null) {
        overviewDelivery.querySelector('.price').textContent = confi.dataset.textFree || '';
      }
    };
    var changePrice = function changePrice(data) {
      lastPriceData = data;
      var amount = prices(data, quantityValue());
      var euroPrice = number2money(amount.price);
      if (confiPrice) confiPrice.textContent = euroPrice;
      if (price) price.textContent = euroPrice;
      if (confiCompare) {
        confiCompare.textContent = amount.onSale ? number2money(amount.uvp) : '';
        confiCompare.hidden = !amount.onSale;
      }
      if (comparePrice) {
        comparePrice.textContent = amount.onSale ? number2money(amount.uvp) : '';
        comparePrice.classList.toggle('hide', !amount.onSale);
      }
      var action = amount.onSale ? 'remove' : 'add';
      document.querySelectorAll('.badge--sale, .product-prices__top').forEach(function (element) {
        element.classList[action]('hide');
      });
      if (savingsNode) {
        savingsNode.textContent = amount.onSale ? fillText(confi.dataset.textSave, number2money(amount.savings)) : '';
        savingsNode.classList.toggle('hide', !amount.onSale);
      }
      if (discountNode) {
        discountNode.textContent = amount.onSale ? '-' + amount.percent + '%' : '';
        discountNode.classList.toggle('hide', !amount.onSale);
      }
      renderOverview(overviewItems(visibleProperties(data), data, overviewTexts, quantityValue()));
    };

    //  3D-Ansicht ( Source/Viewer-3D ) baut die Wand aus Request und Antwort auf
    var showIn3d = function showIn3d(data) {
      if (!definition.wallType) return;
      var detail = viewerDetail(definition.wallType, requestBody(values()), data, terraceLook);
      detail.saveUrl = endpoint('-save');
      window.dispatchEvent(new CustomEvent('Confi-Change', {
        detail: detail
      }));
    };

    ////////////////////////////////////////////////////////////////////////
    //  Preis berechnen ( debounced , ältere Antworten werden verworfen )

    var getInfos = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var list, id, response, data, error, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              list = values();
              if (!(missing(list, definition.required(list)).length > 0)) {
                _context2.n = 1;
                break;
              }
              lock(true);
              return _context2.a(2);
            case 1:
              if (!checkRange(list)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              id = ++sequence;
              _context2.p = 3;
              _context2.n = 4;
              return fetch(endpoint('-infos'), {
                method: 'POST',
                body: JSON.stringify(requestBody(list)),
                headers: ConfiErrors.headers()
              });
            case 4:
              response = _context2.v;
              _context2.n = 7;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              if (!(id !== sequence)) {
                _context2.n = 6;
                break;
              }
              return _context2.a(2);
            case 6:
              console.error(_t2);
              showApiError(ConfiErrors.network());
              return _context2.a(2);
            case 7:
              if (!(id !== sequence)) {
                _context2.n = 8;
                break;
              }
              return _context2.a(2);
            case 8:
              if (response.ok) {
                _context2.n = 10;
                break;
              }
              console.error(response);
              _context2.n = 9;
              return showFailure(response);
            case 9:
              return _context2.a(2);
            case 10:
              _context2.n = 11;
              return response.json();
            case 11:
              data = _context2.v;
              if (!(id !== sequence)) {
                _context2.n = 12;
                break;
              }
              return _context2.a(2);
            case 12:
              error = modelError(data);
              if (!(error !== null && data.error)) {
                _context2.n = 13;
                break;
              }
              showModelError(error);
              return _context2.a(2);
            case 13:
              clearErrors();
              lock(false);
              changePrice(data);
              showIn3d(data);
            case 14:
              return _context2.a(2);
          }
        }, _callee2, null, [[3, 5]]);
      }));
      return function getInfos() {
        return _ref2.apply(this, arguments);
      };
    }();
    var schedule = function schedule() {
      clearTimeout(timer);
      timer = setTimeout(getInfos, Debounce);
    };
    var onChange = function onChange() {
      applyRules();
      schedule();
    };

    ////////////////////////////////////////////////////////////////////////
    //  Warenkorb und Angebot ( wie confi-esg.js )

    var addToShoppingCart = function addToShoppingCart() {
      var isOffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
          var list, response, wallData, code, properties, payload, _t3;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (event) event.preventDefault();
                list = values();
                if (!(missing(list, definition.required(list)).length > 0)) {
                  _context3.n = 1;
                  break;
                }
                lock(true);
                return _context3.a(2);
              case 1:
                if (!checkRange(list)) {
                  _context3.n = 2;
                  break;
                }
                return _context3.a(2);
              case 2:
                // Speichern läuft : Buttons sperren , Preis bleibt gültig
                lock(true, false);
                _context3.p = 3;
                _context3.n = 4;
                return fetch(endpoint('-save'), {
                  method: 'POST',
                  body: JSON.stringify(requestBody(list)),
                  headers: ConfiErrors.headers()
                });
              case 4:
                response = _context3.v;
                _context3.n = 6;
                break;
              case 5:
                _context3.p = 5;
                _t3 = _context3.v;
                console.error(_t3);
                showApiError(ConfiErrors.network());
                return _context3.a(2);
              case 6:
                if (response.ok) {
                  _context3.n = 8;
                  break;
                }
                console.error(response);
                _context3.n = 7;
                return showFailure(response);
              case 7:
                return _context3.a(2);
              case 8:
                _context3.n = 9;
                return response.json();
              case 9:
                wallData = _context3.v;
                code = wallData.code; // Sichtbare Properties wie in der Zusammenfassung , 'signed' bleibt unverändert
                properties = buildCartProperties(Object.assign({}, wallData, {
                  properties: visibleProperties(wallData)
                }), lastPriceData);
                payload = {
                  properties: properties,
                  quantity: quantityValue(),
                  id: Number(variant_id),
                  line_price: wallData.price,
                  price: wallData.price
                };
                if (window.Tracking) {
                  Tracking.addItem({
                    isOffer: isOffer,
                    code: code,
                    payload: _objectSpread(_objectSpread({}, payload), {}, {
                      handle: product_handle
                    })
                  });
                }
                if (!(document.documentElement.dataset.preventRedirect === 'true')) {
                  _context3.n = 10;
                  break;
                }
                lock(false);
                return _context3.a(2);
              case 10:
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(payload)
                }).then(function (response) {
                  return response.json();
                }).then(function () {
                  if (isOffer) {
                    setTimeout(function () {
                      sessionStorage.setItem('Offer:Form', String(true));
                      location.href = "/cart";
                    }, 500);
                  } else {
                    lock(false);
                    setTimeout(function () {
                      fetch('/cart.json').then(function (response) {
                        return response.json();
                      }).then(function (cart) {
                        var icon = document.getElementById('shopping-cart-icon');
                        if (icon) {
                          icon.src = cart.item_count > 0 ? icon.dataset.iconFilled : icon.dataset.iconEmpty;
                        }
                        document.querySelectorAll('.item-count').forEach(function (element) {
                          element.innerHTML = cart.item_count;
                        });
                      })["catch"](function (error) {
                        console.error('Fehler:', error);
                      });
                    }, 500);
                    popupShoppingCart(payload);
                  }
                })["catch"](function (error) {
                  console.error('Fehler:', error);
                  lock(false);
                });
              case 11:
                return _context3.a(2);
            }
          }, _callee3, null, [[3, 5]]);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }();
    };

    ////////////////////////////////////////////////////////////////////////
    //  Gespeicherte Konfiguration laden ( „Bearbeiten“ aus dem Warenkorb )

    var loadConfig = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(code) {
        var response, data, list, _path7, _path8, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch(endpoint('-info/') + encodeURIComponent(code), {
                headers: ConfiErrors.headers(false)
              });
            case 1:
              response = _context4.v;
              if (!response.ok) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return response.json();
            case 2:
              data = _context4.v;
              list = definition.fromInfo(data);
              for (_path7 in list) {
                if (fields[_path7]) writeField(fields[_path7], list[_path7]);
              }
              // Grenzen erst zu den geladenen Werten , dann formatieren
              applyRules();
              for (_path8 in list) {
                if (fields[_path8] && isDecimalField(fields[_path8])) formatField(fields[_path8]);
              }
              loadedFromCode = true;
              _context4.n = 4;
              break;
            case 3:
              console.error(response);
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t4 = _context4.v;
              console.error(_t4);
            case 6:
              applyRules();
              getInfos();
            case 7:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 5]]);
      }));
      return function loadConfig(_x3) {
        return _ref4.apply(this, arguments);
      };
    }();

    ////////////////////////////////////////////////////////////////////////
    var _loop3 = function _loop3() {
      var element = fields[_path9];
      if (isDecimalField(element)) {
        // Beim Verlassen auf min / max begrenzen und formatieren ( 380,0 ) ;
        // beim Tippen nur rechnen , wenn der Wert schon passt
        element.addEventListener('change', function () {
          formatField(element);
          onChange();
        });
        element.addEventListener('input', function () {
          filterField(element);
          if (inRange(element)) onChange();else lock(true);
        });
        return 1; // continue
      }
      element.addEventListener('change', onChange);
      if (element.tagName === 'INPUT' && element.type !== 'checkbox') {
        element.addEventListener('input', onChange);
      }
    };
    for (var _path9 in fields) {
      if (_loop3()) continue;
    }

    //  Optik wechseln baut nur die 3D-Ansicht neu , ohne die API
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-viewer-look]');
      if (button === null) return;
      event.preventDefault();
      terraceLook = button.dataset.viewerLook;
      lookButtons().forEach(function (node) {
        node.setAttribute('aria-pressed', String(node.dataset.viewerLook === terraceLook));
      });
      if (lastPriceData !== null) showIn3d(lastPriceData);
    });
    if (quantity) {
      var rerender = function rerender() {
        return setTimeout(function () {
          if (lastPriceData !== null) changePrice(lastPriceData);
        }, 0);
      };
      quantity.addEventListener('change', rerender);
      quantity.parentElement.querySelectorAll('span').forEach(function (span) {
        span.addEventListener('click', rerender);
      });
    }
    shoppingCartBtn.addEventListener('click', addToShoppingCart(false));
    if (shoppingOfferBtn) shoppingOfferBtn.addEventListener('click', addToShoppingCart(true));
    lock(true);
    applyRules();
    Object.values(fields).filter(isDecimalField).forEach(formatField);
    var code = new URLSearchParams(location.search).get('code');
    if (code) {
      loadConfig(code);
    } else {
      applyRules();
      getInfos();
    }
  };
  var ConfiWall = {
    number: number,
    bool: bool,
    missing: missing,
    withoutFrontPosition: withoutFrontPosition,
    clamp: clamp,
    formatDecimal: formatDecimal,
    decimalText: decimalText,
    outOfRange: outOfRange,
    modelError: modelError,
    prices: prices,
    overviewItems: overviewItems,
    viewerDetail: viewerDetail,
    start: start
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = ConfiWall;
  }
  if (root) {
    root.ConfiWall = ConfiWall;
  }
})(typeof window !== 'undefined' ? window : null);